import React from "react";
import { Icon } from "components/SvgIcons";
import { BtnToolBarWrap, BtnToolColumn, BtnTool, BtnToolbarRecipe, BtnToolbarItemRecipe } from "./styled";
import { BtnsGroupWrapCentered, ItemBtnGroup } from "shared/BtnsGroup/styled";
import Button from "shared/Button";
import { colors } from "styles/colors";
import { PopupSocial } from "./PopupSocial";

import { useRenderDevice } from "helpers/hooks/useRenderDevice";

const BtnToolBar = ({ btns, onSave, saved, socialImgUrl, isRecipe, onClick = () => {}, recipeId, mealPlanId }) => {
  const isMobile = useRenderDevice({ max: 769 });

  return isRecipe ? (
    <BtnToolbarRecipe>
      {btns.map((item) =>
        item.name === "Share" && item.disabled ? (
          <BtnToolbarItemRecipe
            saved={item.name === "Like" && saved}
            key={item.name}
            onClick={item.name === "Like" ? onSave : onClick}
          >
            {item.name === "Like" && saved ? <Icon icon="savedslide" /> : <Icon icon={item.icon} />}
          </BtnToolbarItemRecipe>
        ) : item.name === "Share" ? (
          <PopupSocial
            key={item.name}
            item={item}
            socialImgUrl={socialImgUrl}
            isRecipe={isRecipe}
            recipeId={recipeId}
          />
        ) : (
          <BtnToolbarItemRecipe
            saved={item.name === "Like" && saved}
            key={item.name}
            onClick={item.name === "Like" ? onSave : onClick}
          >
            {item.name === "Like" && saved ? <Icon icon="savedslide" /> : <Icon icon={item.icon} />}
          </BtnToolbarItemRecipe>
        )
      )}
    </BtnToolbarRecipe>
  ) : isMobile ? (
    <BtnsGroupWrapCentered>
      {btns.map((item) =>
        item.name === "Share" && item.disabled ? (
          <ItemBtnGroup saved={item.name === "Like" && saved} key={item.name}>
            <Button
              color={colors.WHITE}
              textColor={item.name === "Like" && saved ? colors.RED : colors.GREY_DARK}
              stylType="outline"
              text={item.name === "Like" && saved ? "Liked" : item.name}
              iconRight={item.name === "Like" && saved ? "savedslide" : item.icon}
              onClick={item.name === "Like" ? onSave : onClick}
            />
          </ItemBtnGroup>
        ) : item.name === "Share" ? (
          <PopupSocial key={item.name} item={item} socialImgUrl={socialImgUrl} mealPlanId={mealPlanId} />
        ) : (
          <ItemBtnGroup saved={item.name === "Like" && saved} key={item.name}>
            <Button
              color={colors.WHITE}
              textColor={item.name === "Like" && saved ? colors.RED : colors.GREY_DARK}
              stylType="outline"
              text={item.name === "Like" && saved ? "Liked" : item.name}
              iconRight={item.name === "Like" && saved ? "savedslide" : item.icon}
              onClick={item.name === "Like" ? onSave : onClick}
            />
          </ItemBtnGroup>
        )
      )}
    </BtnsGroupWrapCentered>
  ) : (
    <BtnToolBarWrap>
      {btns.map((item) =>
        item.name === "Share" && item.disabled ? (
          <BtnToolColumn saved={item.name === "Like" && saved} key={item.name}>
            <BtnTool onClick={item.name === "Like" ? onSave : onClick}>
              {item.name === "Like" && saved ? <Icon icon="savedslide" /> : <Icon icon={item.icon} />}
              {item.name === "Like" && saved ? "Liked" : item.name}
            </BtnTool>
          </BtnToolColumn>
        ) : item.name === "Share" ? (
          <PopupSocial key={item.name} item={item} socialImgUrl={socialImgUrl} mealPlanId={mealPlanId} />
        ) : (
          <BtnToolColumn saved={item.name === "Like" && saved} key={item.name}>
            <BtnTool onClick={item.name === "Like" ? onSave : onClick}>
              {item.name === "Like" && saved ? <Icon icon="savedslide" /> : <Icon icon={item.icon} />}
              {item.name === "Like" && saved ? "Liked" : item.name}
            </BtnTool>
          </BtnToolColumn>
        )
      )}
    </BtnToolBarWrap>
  );
};

export default BtnToolBar;
